import React, { useEffect, useMemo, useState } from 'react'
import { trans } from 'sharedKernel/i18n'
import { DEFAULT_OPPORTUNITY_IMAGE } from '../../../constants'
import type { IOpportunitySupportFile, IStartupOpportunityDetail } from '../../../contracts'
import { getResolverOpportunityCoverImage } from '../../../behavior'
import {
  CoverBanner,
  CoverBannerWrapper,
} from 'domain/feature/hub/company/scouting/VisualizationScreen/components/ScoutingAbout/styles'

interface OpportunityDetailCoverProps {
  opportunity: IStartupOpportunityDetail
  fileRows?: IOpportunitySupportFile[]
}

export const OpportunityDetailCover = ({
  opportunity,
  fileRows,
}: OpportunityDetailCoverProps): JSX.Element => {
  const defaultCoverSrc = useMemo(
    () => getResolverOpportunityCoverImage(opportunity, fileRows),
    [opportunity, fileRows]
  )
  const [coverSrc, setCoverSrc] = useState(defaultCoverSrc)

  useEffect(() => {
    setCoverSrc(defaultCoverSrc)
  }, [defaultCoverSrc])

  return (
    <CoverBannerWrapper>
      <CoverBanner
        src={coverSrc}
        alt={opportunity.title || trans('scouting.about.coverAlt')}
        onError={() => setCoverSrc(DEFAULT_OPPORTUNITY_IMAGE)}
      />
    </CoverBannerWrapper>
  )
}
